import { useDispatch, useSelector } from 'react-redux';
import style from './UserNavigation.module.css';

import { logOut } from '../../../redux/auth/operations';
import { FaPowerOff } from 'react-icons/fa';

import { selectUser } from '../../../redux/auth/selectors.js';
import { FaBell } from 'react-icons/fa';
import { BsFillBellSlashFill } from 'react-icons/bs';
import { selectIsMuted } from '../../../redux/settings/selectors.js';
import { setMuted } from '../../../redux/settings/slice.js';
import { useWebSocket } from '../../WebSocketProvider/WebSocketProvider.jsx';
import useMeeting from '../../../hooks/useMeeting.js';

const UserNavigation = ({}) => {
  const { sendData } = useWebSocket();
  const user = useSelector(selectUser);
  const isPaidUser = user?.typeAccount === 'paidUser';
  const isFreeUser = user?.typeAccount === 'freeUser';

  const isMuted = useSelector(selectIsMuted);
  const { stopLogOutMeeting } = useMeeting({ isFreeUser, user });
  const dispatch = useDispatch();
  const handleClick = async () => {
    console.log('start logout');

    await stopLogOutMeeting(isFreeUser, user);
    sendData({ id: user._id }, 'removeOnlineUser');
    dispatch(logOut());
  };

  const handleChangeMuted = () => {
    dispatch(setMuted(!isMuted));
  };
  return (
    <div className={style.logoutContainer}>
      <h1>Online Dating</h1>

      {isPaidUser && (
        <div className={style.notificationWrapper}>
          {!isMuted && (
            <FaBell
              color="white"
              className={style.notification}
              onClick={handleChangeMuted}
            />
          )}

          {isMuted && (
            <BsFillBellSlashFill
              color="white"
              className={style.notification}
              onClick={handleChangeMuted}
            />
          )}
        </div>
      )}

      <button className={style.logoutButton} onClick={handleClick}>
        <FaPowerOff className={style.logoutIcon} />
        Log Out
      </button>
    </div>
  );
};

export default UserNavigation;
